<a href={fields?.link} class="leaderboard-scroll-button">
  <p>Scroll for more</p>
  <svg fill={fields.iconColour || '#fff'} xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50">
    <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"/>
  </svg>
</a>

<script>
  export let fields = {}
</script>

<style lang="scss">.leaderboard-scroll-button {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.leaderboard-scroll-button svg {
  transition: 0.3s;
  transform: translateY(-10px);
}
.leaderboard-scroll-button:hover {
  cursor: pointer;
}
.leaderboard-scroll-button:hover svg {
  transform: translateY(-4px);
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>